import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  (theme) => ({
    button: {
      padding: theme.spacing(1.75, 2),
      marginTop: '22px',
      width: '100%',
    },
    top: {
      margin: 'auto',
      textAlign: 'right',
    },
    label: {
      color: theme.palette.common.black,
    },
    input_box: {
      paddingRight: '5px',
      paddingLeft: '5px',
      width: '100%',
    },
    isd_code: {
      background: '#BDBDBD',
      paddingTop: '15px',
      paddingLeft: '10px',
      paddingRight: '10px',
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
      borderTopRightRadius: '0px',
      borderBottomRightRadius: '0px',
    },
    phone: {
      width: '100%',
      '& > .MuiFormHelperText-root.Mui-error, & > .MuiFormHelperText-contained':
        {
          position: 'absolute',
          top: '100%',
          marginLeft: 0,
        },
      '& > .MuiInputBase-formControl  > .MuiOutlinedInput-notchedOutline': {
        borderLeft: 'none',
        borderTopLeftRadius: '0px',
        borderBottomLeftRadius: '0px',
      },
      '&:hover > .MuiInputBase-formControl  > .MuiOutlinedInput-notchedOutline':
        {
          border: '1px solid #c4c4c4;',
          borderLeft: 'none',
          borderTopLeftRadius: '0px',
          borderBottomLeftRadius: '0px',
        },
    },
    email: {
      width: '100%',
      '& > .MuiFormHelperText-root.Mui-error, & > .MuiFormHelperText-contained':
        {
          position: 'absolute',
          top: '100%',
          marginLeft: 0,
        },
      '& > .MuiInputBase-formControl  > .MuiOutlinedInput-notchedOutline': {
        borderRight: 'none',
        borderTopRightRadius: '0px',
        borderBottomRightRadius: '0px',
      },
      '&:hover > .MuiInputBase-formControl  > .MuiOutlinedInput-notchedOutline':
        {
          border: '1px solid #c4c4c4;',
          borderRight: 'none',
          borderTopRightRadius: '0px',
          borderBottomRightRadius: '0px',
        },
    },
    search_icon_box: {
      border: '1px solid #c4c4c4;',
      borderLeft: 'none',
      borderTopLeftRadius: '0px',
      borderBottomLeftRadius: '0px',
    },
    search_icon: {
      fontSize: '30px',
    },
    success_popup: {
      width: '100%',
      textAlign: 'center',
      padding: '16px',
      margin: '6px 0',
      borderRadius: '4px',
    },
  }),
  { name: 'InviteNewUser' }
);

export default useStyles;
